import { memo } from "react";
import isEqual from "react-fast-compare";

function Divider({ id }: { id: string }) {
	return <div className="border-t border-gray-100 mx-5 pb-4 mt-2" />;
}

export default memo(Divider, isEqual);
